import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import db from '@/utils/db'

Vue.use(VueI18n)

const messages = {
	en: {
		...enLocale
	},
	zh: {
		...zhLocale
	}
}

// 默认国际化
//console.log('navigator.language:', navigator.language)
const locale = db.get('sys.public.language.value').value() || 'zh'
// const locale = 'zh'

const i18n = new VueI18n({
	locale,
	messages
})

export default i18n

// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import enLocale from './en'
// import zhLocale from './zh'
// import db from '@/utils/db'
//
// // Vue.use(VueI18n)
//
// const messages = {
//     en: {
//         ...enLocale,
//     },
//     zh: {
//         ...zhLocale,
//     }
// }
//
// // 默认国际化
// const locale = db.get('sys.public.language.value').value() || 'zh'
//
// const i18n = new VueI18n({
//     locale,
//     messages
// })
//
// console.log('i18n is 222', i18n)
//
// export default i18n
